import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { cn } from '@/lib/utils';
    import { DialogDescription, type DialogDescriptionProps, useForwardProps } from 'reka-ui';
    import { computed, type HTMLAttributes } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DialogDescription',
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {}
  },
  setup(__props: any) {

    const props = __props;

    const delegatedProps = computed(() => {
        const { class: _, ...delegated } = props;

        return delegated;
    });

    const forwardedProps = useForwardProps(delegatedProps);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogDescription), _mergeProps({ "data-slot": "dialog-description" }, _unref(forwardedProps), {
    class: _unref(cn)('text-muted-foreground text-sm', props.class)
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})